<template>
  <!-- 仅保留路由视图容器，所有页面通过路由匹配渲染到这里 -->
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* 重置全局样式，避免默认样式干扰后台管理系统布局 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  width: 100%;
  height: 100vh; /* 全屏高度，适配布局组件 */
  font-family: "Microsoft YaHei", Arial, Helvetica, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>